import { Item } from "@coworker/apprestructured/src/shared/types/item";

/**
 * Maps an array of items to a Map keyed by item number for O(1) lookup
 */
export const mapItemsByNo = (
  items: (Item | undefined)[]
): Map<string, Item> => {
  const map = new Map<string, Item>();
  items.forEach((item) => {
    if (item?.no) {
      map.set(item.no, item);
    }
  });
  return map;
};
